// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MeditateActuallyFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M48.003 25.037c-12.664 0-22.966 10.303-22.966 22.967 0 12.66 10.302 22.959 22.966 22.959 12.66 0 22.96-10.299 22.96-22.959 0-12.664-10.3-22.967-22.96-22.967Zm.001 62.463C26.222 87.5 8.5 69.783 8.5 48.007 8.5 26.223 26.222 8.5 48.004 8.5 69.782 8.5 87.5 26.223 87.5 48.007 87.5 69.783 69.782 87.5 48.004 87.5Z"
			fill="#fff"
		/>
	</svg>
);
export default MeditateActuallyFilled;
